/** The phone breakpoint every section in this package shares. */
export const MOBILE_MAX = 749;
/**
 * Wide → tall. The labels name the shape a seller is looking for ("Story", "Tall") and then the ratio, so
 * the list is scannable by someone who has never thought in ratios.
 *
 * Values are CSS ratios and they are STORED — renaming one would silently unset every section using it.
 */
export const ASPECT_RATIO_OPTIONS = [
    { value: '21/9', label: 'Panorama 21:9' },
    { value: '16/9', label: 'Wide 16:9' },
    { value: '3/2', label: 'Landscape 3:2' },
    { value: '4/3', label: 'Landscape 4:3' },
    { value: '1/1', label: 'Square' },
    { value: '4/5', label: 'Portrait 4:5' },
    { value: '3/4', label: 'Portrait 3:4' },
    { value: '2/3', label: 'Portrait 2:3' },
    { value: '9/16', label: 'Story 9:16' },
    { value: '1/2', label: 'Tall 1:2' },
    { value: '1/3', label: 'Very tall 1:3' },
];
/** The help text under a mobile shape control — identical wherever the field is offered. */
export const MOBILE_ASPECT_INFO = 'A phone is narrow and tall: a shape that reads well in a desktop row is often a letterbox slit here. Leave it on “Same as desktop” to use one shape everywhere.';
/**
 * The mobile shape's options: “same as desktop”, then the desktop list, `headOption` first.
 *
 * @param headOption the section's own "the file decides" entry — `natural` for an image, `auto` for a video.
 */
export function mobileAspectOptions(headOption) {
    return [{ value: 'inherit', label: 'Same as desktop' }, headOption, ...ASPECT_RATIO_OPTIONS];
}
/**
 * A stored shape → a CSS `aspect-ratio` value, or `undefined` when the file decides (`natural`, `auto`,
 * `inherit`, absent, or anything this list does not recognise).
 *
 * The value comes from an untyped JSON document and lands in a `<style>` element, so it is MATCHED against
 * the list rather than passed through — an arbitrary string here would close the rule and open its own.
 */
export function cssAspectRatio(value) {
    if (typeof value !== 'string')
        return undefined;
    return ASPECT_RATIO_OPTIONS.some((o) => o.value === value) ? value : undefined;
}
/**
 * The scoped CSS for a per-device shape, or `''` when nothing needs to be said.
 *
 * Emits the DESKTOP ratio as a plain rule (not inside `min-width`, so it is also the fallback anywhere the
 * queries do not apply) and the mobile one inside the two phone queries. `mobileShape === 'inherit'`
 * returns `''`: the caller then keeps its inline ratio and this engine costs a live storefront nothing.
 */
export function aspectCss(selector, desktopRatio, mobileShape) {
    if (typeof mobileShape !== 'string' || mobileShape === 'inherit' || mobileShape === '')
        return '';
    // `auto` is a real CSS keyword and it is exactly what "the file decides" means for a box that would
    // otherwise inherit the desktop ratio — so the two "no crop" shapes need no special case here.
    const mobileRatio = cssAspectRatio(mobileShape) ?? 'auto';
    const q = `(max-width:${MOBILE_MAX}px)`;
    return (`${selector}{aspect-ratio:${desktopRatio ?? 'auto'}}` +
        `@media${q}{${selector}{aspect-ratio:${mobileRatio}}}` +
        `@container aqx-page ${q}{${selector}{aspect-ratio:${mobileRatio}}}`);
}
//# sourceMappingURL=aspect.js.map